// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "form_service_requirement".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "form_service_requirement" table (1:1 with a DB row, on the wire). */
export const formServiceRequirementAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    formId: z.string(),
    serviceId: z.string(),
    blocksBooking: z.boolean(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=formServiceRequirement.js.map